export const DATA_ACCESS_ERROR_HANDLER_SERVICE_TOKEN = Symbol(
  'DATA_ACCESS_ERROR_HANDLER_SERVICE_TOKEN'
);

export class DataAccessErrorHandlerService {
  public handleError(error: Error): void {
    console.error(error);
  }
}
